import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-723">
      <PriceAlert data-id="element-724" />
      <Hero data-id="element-725" />
      <Testimonial data-id="element-726" />
      <ProblemSolution data-id="element-727" />
      <ValueStack data-id="element-728" />
      <ModuleBreakdown data-id="element-729" />
      <Guarantee data-id="element-730" />
      <PricingSection data-id="element-731" />
      <Footer data-id="element-732" />
      <RecentPurchaseToast data-id="element-733" />
    </div>;
}